export default __webpack_public_path__ + "static/media/smiley5-filled.0b3b65f8.svg";